/**
 * Recently opened things, for the Home page. Kept per browser (like history),
 * newest first, at most 40 entries.
 */
import { createStore, readPref, useStore, writePref } from "./ui";
import type { Id } from "./types";

export type RecentKind = "issue" | "project" | "initiative" | "document" | "idea" | "cycle" | "view" | "dashboard" | "customer";

export interface Recent {
  kind: RecentKind;
  id: Id;
  at: string;
}

const KEY = "recents";
const MAX = 40;

export const recentsStore = createStore<Recent[]>(readPref<Recent[]>(KEY, []));
export const useRecents = () => useStore(recentsStore);

export function recordVisit(kind: RecentKind, id: Id) {
  recentsStore.set((list) => {
    const head = list[0];
    // The same page re-rendering shouldn't churn the list.
    if (head && head.kind === kind && head.id === id) return list;
    const next = [{ kind, id, at: new Date().toISOString() }, ...list.filter((r) => !(r.kind === kind && r.id === id))].slice(0, MAX);
    writePref(KEY, next);
    return next;
  });
}

export function forgetRecent(kind: RecentKind, id: Id) {
  recentsStore.set((list) => {
    const next = list.filter((r) => !(r.kind === kind && r.id === id));
    writePref(KEY, next);
    return next;
  });
}

export function clearRecents() {
  writePref(KEY, []);
  recentsStore.set([]);
}
